import { State } from '../configure-store';

export const getStatusFilter = (state: State): string => {
  const status = state.membersTable.filters?.status;
  if (!status) {
    return 'All';
  } else {
    return status;
  }
};
